export default {
  skin_switched_successfully: {
    evid: 1615,
    src: 38,
    fields: {
      component_id: 'string',
      component_type: 'string',
    },
  },
  skin_switching_error: {
    evid: 1616,
    src: 38,
    fields: {
      component_id: 'string',
      component_type: 'string',
      error_code: 'string',
      error_message: 'string',
    },
  },
} as const;
